/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { UpdateAvailableMerchantCategories200ResponseAvailableMerchantCategoriesInner } from './update-available-merchant-categories200-response-available-merchant-categories-inner';
// May contain unused imports in some cases
// @ts-ignore
import { UpdateAvailableMerchantCategories200ResponseReissue } from './update-available-merchant-categories200-response-reissue';
// May contain unused imports in some cases
// @ts-ignore
import { UpdateAvailableMerchantCategories200ResponseUser } from './update-available-merchant-categories200-response-user';
// May contain unused imports in some cases
// @ts-ignore
import { UpdateAvailableMerchantCategories200ResponseUserAccountGroup } from './update-available-merchant-categories200-response-user-account-group';

/**
 * 
 * @export
 * @interface UpdateAvailableMerchantCategories200Response
 */
export interface UpdateAvailableMerchantCategories200Response {
    /**
     * 
     * @type {string}
     * @memberof UpdateAvailableMerchantCategories200Response
     */
    'cardId': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAvailableMerchantCategories200Response
     */
    'cardLabel': string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAvailableMerchantCategories200Response
     */
    'isActivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAvailableMerchantCategories200Response
     */
    'isDeactivated': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAvailableMerchantCategories200Response
     */
    'isLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAvailableMerchantCategories200Response
     */
    'isFraudLocked': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAvailableMerchantCategories200Response
     */
    'isSuspended': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAvailableMerchantCategories200Response
     */
    'isFrozen': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAvailableMerchantCategories200Response
     */
    'isVirtualCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAvailableMerchantCategories200Response
     */
    'isCreditCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAvailableMerchantCategories200Response
     */
    'isOnDemand': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAvailableMerchantCategories200Response
     */
    'isMetalCard': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAvailableMerchantCategories200Response
     */
    'isPhysicalStorePaymentDisabled': boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateAvailableMerchantCategories200Response
     */
    'panLastFourDigits': string;
    /**
     * 
     * @type {string}
     * @memberof UpdateAvailableMerchantCategories200Response
     */
    'userAccountId': string;
    /**
     * 
     * @type {number}
     * @memberof UpdateAvailableMerchantCategories200Response
     */
    'transactionUpperLimit': number | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateAvailableMerchantCategories200Response
     */
    'availableCurrencies': Array<UpdateAvailableMerchantCategories200ResponseAvailableCurrenciesEnum>;
    /**
     * 
     * @type {Array<UpdateAvailableMerchantCategories200ResponseAvailableMerchantCategoriesInner>}
     * @memberof UpdateAvailableMerchantCategories200Response
     */
    'availableMerchantCategories': Array<UpdateAvailableMerchantCategories200ResponseAvailableMerchantCategoriesInner> | null;
    /**
     * 
     * @type {UpdateAvailableMerchantCategories200ResponseUser}
     * @memberof UpdateAvailableMerchantCategories200Response
     */
    'user': UpdateAvailableMerchantCategories200ResponseUser;
    /**
     * 
     * @type {UpdateAvailableMerchantCategories200ResponseUserAccountGroup}
     * @memberof UpdateAvailableMerchantCategories200Response
     */
    'userAccountGroup'?: UpdateAvailableMerchantCategories200ResponseUserAccountGroup | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateAvailableMerchantCategories200Response
     */
    'monthlyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateAvailableMerchantCategories200Response
     */
    'monthlyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateAvailableMerchantCategories200Response
     */
    'dailyTotalUsage': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateAvailableMerchantCategories200Response
     */
    'dailyUsageLimit': number | null;
    /**
     * 
     * @type {number}
     * @memberof UpdateAvailableMerchantCategories200Response
     */
    'totalUsageAmount': number;
    /**
     * 
     * @type {number}
     * @memberof UpdateAvailableMerchantCategories200Response
     */
    'totalUsageAmountLimit': number | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateAvailableMerchantCategories200Response
     * @deprecated
     */
    'expiredDate': string | null;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAvailableMerchantCategories200Response
     * @deprecated
     */
    'isRenewalProcessing': boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateAvailableMerchantCategories200Response
     * @deprecated
     */
    'isAutoRenewalOnExpiration': boolean;
    /**
     * 
     * @type {UpdateAvailableMerchantCategories200ResponseReissue}
     * @memberof UpdateAvailableMerchantCategories200Response
     */
    'reissue'?: UpdateAvailableMerchantCategories200ResponseReissue | null;
}

export const UpdateAvailableMerchantCategories200ResponseAvailableCurrenciesEnum = {
    jpy: 'JPY',
    usd: 'USD',
    gbp: 'GBP',
    eur: 'EUR',
    sgd: 'SGD',
    aud: 'AUD',
    cny: 'CNY',
    hkd: 'HKD',
    idr: 'IDR',
    krw: 'KRW',
    nzd: 'NZD',
    php: 'PHP',
    rub: 'RUB',
    vnd: 'VND',
    inr: 'INR',
    thb: 'THB',
    lak: 'LAK',
    myr: 'MYR',
    twd: 'TWD',
    chf: 'CHF',
    cad: 'CAD',
    mxn: 'MXN',
    nok: 'NOK',
    huf: 'HUF',
    hrk: 'HRK',
    czk: 'CZK',
    dkk: 'DKK',
    isk: 'ISK',
    mdl: 'MDL',
    sek: 'SEK',
    mkd: 'MKD',
    rsd: 'RSD',
    ron: 'RON',
    bgn: 'BGN',
    bam: 'BAM',
    pln: 'PLN',
    mad: 'MAD',
    zar: 'ZAR',
    rwf: 'RWF',
    kes: 'KES',
    ngn: 'NGN',
    aed: 'AED',
    sar: 'SAR',
    egp: 'EGP',
    qar: 'QAR',
    omr: 'OMR',
    ils: 'ILS',
    try: 'TRY',
    kzt: 'KZT',
    cop: 'COP',
    gtq: 'GTQ'
} as const;

export type UpdateAvailableMerchantCategories200ResponseAvailableCurrenciesEnum = typeof UpdateAvailableMerchantCategories200ResponseAvailableCurrenciesEnum[keyof typeof UpdateAvailableMerchantCategories200ResponseAvailableCurrenciesEnum];


